import { useCallback, useEffect, useState } from 'react'
import useSound from 'use-sound'

import pressDownSound from './audio/press-down.mp3'
import pressUpSound from './audio/press-up.mp3'

const KEY = 'invo.cashRegister.keySound'
const EVENT = 'invo:key-sound'

const read = () => {
  try {
    return localStorage.getItem(KEY) !== 'off'
  } catch {
    return true
  }
}

/** Zvuk kláves kalkulačky. Zapnutí se pamatuje v prohlížeči, tedy zvlášť pro každé zařízení. */
export const useKeySound = () => {
  const [enabled, setEnabled] = useState(read)
  const [pressDown] = useSound(pressDownSound, { soundEnabled: enabled })
  const [pressUp] = useSound(pressUpSound, { soundEnabled: enabled })

  useEffect(() => {
    const sync = () => setEnabled(read())
    window.addEventListener('storage', sync)
    window.addEventListener(EVENT, sync)
    return () => {
      window.removeEventListener('storage', sync)
      window.removeEventListener(EVENT, sync)
    }
  }, [])

  const toggle = useCallback(() => {
    const next = !read()
    try {
      localStorage.setItem(KEY, next ? 'on' : 'off')
    } catch {
      // bez localStorage platí jen do obnovení stránky
    }
    setEnabled(next)
    window.dispatchEvent(new Event(EVENT))
  }, [])

  return { enabled, toggle, sound: { onPressDown: pressDown, onPressUp: pressUp } }
}
